import { render, staticRenderFns } from "./QuickActionsCard.vue?vue&type=template&id=602f1b12&scoped=true&"
import script from "./QuickActionsCard.vue?vue&type=script&lang=js&"
export * from "./QuickActionsCard.vue?vue&type=script&lang=js&"
import style0 from "./QuickActionsCard.vue?vue&type=style&index=0&id=602f1b12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602f1b12",
  null
  
)

export default component.exports